import { useEffect, useRef, useCallback } from 'react';
import L from 'leaflet';
import { Marker, Popup } from 'react-leaflet';
import { setItemSelected } from '../services/data-service';

import markerIcon from '../images/marker-icon.png';
import markerIconRetina from '../images/marker-icon-2x.png';

import './item-marker.scss';

const defaultPoi = new L.Icon({
    iconUrl: markerIcon,
    iconRetinaUrl: markerIconRetina,
    iconAnchor: [12, 41],
    iconSize: [25, 41],
    popupAnchor: [0, -40]
});

const ItemMarker = ({data, parent, selected}) => {

    const poi = useRef();

    const events = {
        click: () => setItemSelected(data)
    };

    const updateMarker = useCallback(() => {
        if(!parent) return;
        if(!poi.current) return;
        if(selected){
            parent.zoomToShowLayer( poi.current, () => poi.current.openPopup() );
        } else {
            poi.current.closePopup();
        }
    }, [selected, parent]);

    useEffect(() => {
        updateMarker();
    }, [updateMarker, selected]);

    if(!data.location) return false;

    return(
        <Marker ref={poi} position={data.location} icon={defaultPoi} eventHandlers={events}>
            <Popup closeButton={false}>
                <div>
                    <a href={data.url} target="_blank" rel="noreferrer">{data.titre}</a>
                </div>
            </Popup>
        </Marker>
    );

}

export default ItemMarker;